import { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { FaUser, FaEnvelope, FaLock, FaPhone } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Register.css';

import tutorImg from '../shared/image/Dial_Tutor.png';

export default function StudentRegister() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      await register({ ...form, role: 'student' });
      navigate('/student/dashboard');
    } catch (e2) {
      setErr(e2.message || 'Registration failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container fluid className="mains-containers">
      <Row className="logins-cards">
        <Col md={6} className="images-sections">
          <img src={tutorImg} alt="Dialtutor" />
        </Col>
        <Col md={6} className="forms-sections">
          <h4 className="mb-4">Student Sign up into your account</h4>
          <Form onSubmit={onSubmit}>
            {err && <Alert variant="danger" className="py-2">{err}</Alert>}
            <InputGroup className="mb-3 ingrps">
              <InputGroup.Text><FaUser /></InputGroup.Text>
              <FormControl placeholder="Full name" className="bgins" value={form.name} onChange={set('name')} required />
            </InputGroup>
            <InputGroup className="mb-3 ingrps">
              <InputGroup.Text><FaEnvelope /></InputGroup.Text>
              <FormControl placeholder="Email" type="email" className="bgins" value={form.email} onChange={set('email')} required />
            </InputGroup>
            <InputGroup className="mb-3 ingrps">
              <InputGroup.Text><FaPhone /></InputGroup.Text>
              <FormControl placeholder="Phone" type="tel" className="bgins" value={form.phone} onChange={set('phone')} />
            </InputGroup>
            <InputGroup className="mb-3 ingrps">
              <InputGroup.Text><FaLock /></InputGroup.Text>
              <FormControl type="password" placeholder="Password (min 6)" className="bgins" value={form.password} onChange={set('password')} required />
            </InputGroup>
            <Button className="mb-3 subts" type="submit" disabled={busy}>
              {busy ? '...' : 'Sign Up'}
            </Button>
          </Form>
          <h6>
            Already have an account?{' '}
            <Link to="/student/login" className="custom-text">
              <strong>Login</strong>
            </Link>
          </h6>
        </Col>
      </Row>
    </Container>
  );
}
